<form [formGroup]="form" class="c-resource-edit-form">
  <div class="alert alert-danger" role="group" *ngIf="form.invalid">
    <h2 class="h5" i18n="@@resourceEditForm-errorSummary-heading">
      There's a problem
    </h2>
    <ul class="m-0">
      <li
        *ngIf="form.controls.resource_type.errors?.required"
        i18n="@@resourceEditForm-errorSummary-type"
      >
        Select a resource type
      </li>
      <li
        *ngIf="form.controls.title.errors?.required"
        i18n="@@resourceEditForm-errorSummary-title"
      >
        Enter a resource title
      </li>
    </ul>
  </div>

  <div class="form-group">
    <label
      for="resource_type-{{ id }}"
      i18n="@@resourceEditForm-label-resourceType"
      >Resource type</label
    >
    <select
      id="resource_type-{{ id }}"
      type="text"
      formControlName="resource_type"
      class="form-select"
    >
      <ng-container *ngFor="let type of resourceTypes">
        <option [value]="type">{{ type }}</option>
      </ng-container>
    </select>
    <div
      *ngIf="form.controls.resource_type.errors?.required"
      i18n="@@resourceEditForm-type-required"
      class="field-error"
    >
      A resource type is required
    </div>
  </div>

  <div class="form-group">
    <label for="title-{{ id }}" i18n="@@resourceEditForm-label-title"
      >Title</label
    >
    <input
      id="title-{{ id }}"
      type="text"
      formControlName="title"
      class="form-control"
    />
    <div
      *ngIf="form.controls.title.errors?.required"
      i18n="@@resourceEditForm-title-required"
      class="field-error"
    >
      A title is required
    </div>
  </div>

  <fieldset
    class="qa-resource-edit__contributors"
    *ngIf="visibleFields.fields.authors || visibleFields.fields.editors"
  >
    <legend i18n="@@resourceEditForm-group-contributors">Contributors</legend>

    <div class="clear"></div>

    <ng-container
      formArrayName="authors"
      *ngFor="let author of authors.controls; index as i"
    >
      <fieldset [formGroupName]="i">
        <legend
          i18n="@@resourceEditForm-legend-author"
          class="c-resource-edit-form__legend-subtitle"
        >
          Author
        </legend>
        <div
          class="d-flex gap-2 align-items-baseline"
          *ngIf="author.get('first_name').value || author.get('surname').value"
        >
          <div class="flex-grow-1">
            <div class="form-group">
              <label
                for="author_first_name-{{ id }}-{{ i }}"
                i18n="@@resourceEditForm-label-authorFirstName"
                >First name</label
              >
              <input
                id="author_first_name-{{ id }}-{{ i }}"
                type="text"
                formControlName="first_name"
                class="form-control"
              />
            </div>
          </div>
          <div class="flex-grow-1">
            <div class="form-group">
              <label
                for="author_surname-{{ id }}-{{ i }}"
                i18n="@@resourceEditForm-label-authorSurname"
                >Surname</label
              >
              <input
                id="author_surname-{{ id }}-{{ i }}"
                type="text"
                formControlName="surname"
                class="form-control"
              />
            </div>
          </div>
          <div>
            <rl-field-context-menu
              [field]="{ fieldName: 'authors', index: i }"
              (optionClicked)="onFieldContextMenuOptionClicked($event)"
            ></rl-field-context-menu>
          </div>
        </div>

        <div
          class="d-flex gap-2 align-items-baseline"
          *ngIf="author.get('full_name').value"
        >
          <div class="flex-grow-1">
            <div
              class="form-group"
              *ngIf="
                author.get('full_name').value || visibleFields.fields.authors
              "
            >
              <label
                for="author_full_name-{{ id }}-{{ i }}"
                i18n="@@resourceEditForm-label-authorFullName"
                >Full name</label
              >
              <input
                id="author_full_name-{{ id }}-{{ i }}"
                type="text"
                formControlName="full_name"
                class="form-control"
              />
            </div>
          </div>
          <div>
            <rl-field-context-menu
              [field]="{ fieldName: 'authors', index: i }"
              (optionClicked)="onFieldContextMenuOptionClicked($event)"
            ></rl-field-context-menu>
          </div>
        </div>
      </fieldset>
    </ng-container>

    <ng-container
      formArrayName="editors"
      *ngFor="let editor of editors.controls; index as i"
    >
      <fieldset [formGroupName]="i">
        <legend i18n="@@resourceEditForm-legend-editor">Editor</legend>

        <div
          class="d-flex gap-2 align-items-baseline"
          *ngIf="editor.get('first_name').value || editor.get('surname').value"
        >
          <div class="flex-grow-1">
            <div class="form-group">
              <label
                for="editor_first_name-{{ id }}-{{ i }}"
                i18n="@@resourceEditForm-label-editorFirstName"
                >First name</label
              >
              <input
                id="editor_first_name-{{ id }}-{{ i }}"
                type="text"
                formControlName="first_name"
                class="form-control"
              />
            </div>
          </div>
          <div class="flex-grow-1">
            <div class="form-group">
              <label
                for="editor_surname-{{ id }}-{{ i }}"
                i18n="@@resourceEditForm-label-editorSurname"
                >Surname</label
              >
              <input
                id="editor_surname-{{ id }}-{{ i }}"
                type="text"
                formControlName="surname"
                class="form-control"
              />
            </div>
          </div>
          <div>
            <rl-field-context-menu
              [field]="{ fieldName: 'editors', index: i }"
              (optionClicked)="onFieldContextMenuOptionClicked($event)"
            ></rl-field-context-menu>
          </div>
        </div>

        <div
          class="d-flex gap-2 align-items-baseline"
          *ngIf="editor.get('full_name').value"
        >
          <div class="flex-grow-1">
            <div class="form-group">
              <label
                for="editor_full_name-{{ id }}-{{ i }}"
                i18n="@@resourceEditForm-label-editorFullName"
                >Full name</label
              >
              <input
                id="editor_full_name-{{ id }}-{{ i }}"
                type="text"
                formControlName="full_name"
                class="form-control"
              />
            </div>
          </div>
          <div>
            <rl-field-context-menu
              [field]="{ fieldName: 'editors', index: i }"
              (optionClicked)="onFieldContextMenuOptionClicked($event)"
            ></rl-field-context-menu>
          </div>
        </div>
      </fieldset>
    </ng-container>
  </fieldset>

  <fieldset
    class="qa-resource-edit__publicationDetails"
    *ngIf="
      visibleFields.fields.edition ||
      visibleFields.fields.volume ||
      visibleFields.fields.issue ||
      visibleFields.fields.dates
    "
  >
    <legend i18n="@@resourceEditForm-group-publicationDetails">
      Publication details
    </legend>

    <div
      class="d-flex gap-2 align-items-baseline"
      *ngIf="visibleFields.fields.edition"
    >
      <div class="flex-grow-1">
        <div class="form-group">
          <label for="edition-{{ id }}" i18n="@@resourceEditForm-label-edition"
            >Edition</label
          >
          <input
            id="edition-{{ id }}"
            type="text"
            formControlName="edition"
            class="form-control"
          />
        </div>
      </div>
      <div>
        <rl-field-context-menu
          [field]="{ fieldName: 'edition' }"
          (optionClicked)="onFieldContextMenuOptionClicked($event)"
        ></rl-field-context-menu>
      </div>
    </div>

    <div
      class="d-flex gap-2 align-items-baseline"
      *ngIf="visibleFields.fields.volume"
    >
      <div class="flex-grow-1">
        <div class="form-group">
          <label for="volume-{{ id }}">Volume</label>
          <input
            id="volume-{{ id }}"
            type="text"
            formControlName="volume"
            class="form-control"
          />
        </div>
      </div>
      <div>
        <rl-field-context-menu
          [field]="{ fieldName: 'volume' }"
          (optionClicked)="onFieldContextMenuOptionClicked($event)"
        ></rl-field-context-menu>
      </div>
    </div>

    <div
      class="d-flex gap-2 align-items-baseline"
      *ngIf="visibleFields.fields.issue"
    >
      <div class="flex-grow-1">
        <div class="form-group">
          <label for="issue-{{ id }}" i18n="@@resourceEditForm-label-issue"
            >Issue</label
          >
          <input
            id="issue-{{ id }}"
            type="text"
            formControlName="issue"
            class="form-control"
          />
        </div>
      </div>
      <div>
        <rl-field-context-menu
          [field]="{ fieldName: 'issue' }"
          (optionClicked)="onFieldContextMenuOptionClicked($event)"
        ></rl-field-context-menu>
      </div>
    </div>

    <ng-container
      formArrayName="dates"
      *ngFor="let date of dates.controls; index as i"
    >
      <div class="d-flex gap-2 align-items-baseline">
        <div class="flex-grow-1">
          <div class="form-group" [formGroupName]="i">
            <label
              for="date-{{ id }}-{{ i }}"
              i18n="@@resourceEditForm-label-date"
              >Date</label
            >
            <input
              id="date-{{ id }}-{{ i }}"
              type="text"
              formControlName="date"
              class="form-control"
            />
          </div>
        </div>
        <div>
          <rl-field-context-menu
            [field]="{ fieldName: 'dates', index: i }"
            (optionClicked)="onFieldContextMenuOptionClicked($event)"
          ></rl-field-context-menu>
        </div>
      </div>
    </ng-container>
  </fieldset>

  <fieldset
    class="qa-resource-edit__onlineResource"
    *ngIf="
      visibleFields.fields.online_resource ||
      visibleFields.fields.web_addresses ||
      visibleFields.fields.source_uri
    "
  >
    <legend i18n="@@resourceEditForm-group-onlineResource">
      Online resource
    </legend>

    <ng-container
      *ngIf="visibleFields.fields.online_resource"
      formGroupName="online_resource"
    >
      <div class="d-flex gap-2 align-items-baseline">
        <div class="">
          <div class="form-group">
            <label
              for="onlineResourceSource"
              i18n="@@resourceEditForm-label-onlineResourceSource"
              >Source</label
            >
            <input
              id="onlineResourceSource"
              type="text"
              formControlName="source"
              class="form-control"
            />
          </div>
        </div>
        <div class="flex-grow-1">
          <div class="form-group">
            <label
              for="onlineResourceLink"
              i18n="@@resourceEditForm-label-onlineResourceLink"
              >Link</label
            >
            <input
              id="onlineResourceLink"
              type="text"
              formControlName="link"
              class="form-control"
            />
          </div>
        </div>
        <div>
          <rl-field-context-menu
            [field]="{ fieldName: 'online_resource' }"
            (optionClicked)="onFieldContextMenuOptionClicked($event)"
          ></rl-field-context-menu>
        </div>
      </div>
    </ng-container>

    <ng-container
      formArrayName="web_addresses"
      *ngFor="let webAddress of web_addresses.controls; index as i"
    >
      <div class="d-flex gap-2 align-items-baseline">
        <div class="flex-grow-1">
          <div class="form-group" [formGroupName]="i">
            <label
              for="webAddress-{{ id }}-{{ i }}"
              i18n="@@resourceEditForm-label-webAddress"
              >Web Address</label
            >
            <input
              id="webAddress-{{ id }}-{{ i }}"
              type="text"
              formControlName="webAddress"
              class="form-control"
            />
          </div>
        </div>
        <div>
          <rl-field-context-menu
            [field]="{ fieldName: 'web_addresses', index: i }"
            (optionClicked)="onFieldContextMenuOptionClicked($event)"
          ></rl-field-context-menu>
        </div>
      </div>
    </ng-container>

    <div
      class="d-flex gap-2 align-items-baseline"
      *ngIf="visibleFields.fields.source_uri"
    >
      <div class="flex-grow-1">
        <div class="form-group">
          <label
            for="sourceUri-{{ id }}"
            i18n="@@resourceEditForm-label-sourceUri"
            >Source URI</label
          >
          <input
            id="sourceUri-{{ id }}"
            type="text"
            formControlName="source_uri"
            class="form-control"
          />
        </div>
      </div>
      <div>
        <rl-field-context-menu
          [field]="{ fieldName: 'source_uri' }"
          (optionClicked)="onFieldContextMenuOptionClicked($event)"
        ></rl-field-context-menu>
      </div>
    </div>
  </fieldset>

  <fieldset
    class="qa-resource-edit__identifiers"
    *ngIf="
      visibleFields.fields.doi ||
      visibleFields.fields.lcn ||
      visibleFields.fields.optionalIsbn10s ||
      visibleFields.fields.optionalIsbn13s ||
      visibleFields.fields.issns ||
      visibleFields.fields.eissns
    "
  >
    <legend i18n="@@resourceEditForm-group-identifiers">Identifiers</legend>

    <div
      class="d-flex gap-2 align-items-baseline"
      *ngIf="visibleFields.fields.doi"
    >
      <div class="flex-grow-1">
        <div class="form-group">
          <label for="doi-{{ id }}" i18n="@@resourceEditForm-label-doi"
            >DOI</label
          >
          <input
            id="doi-{{ id }}"
            type="text"
            formControlName="doi"
            class="form-control"
          />
        </div>
      </div>
      <div>
        <rl-field-context-menu
          [field]="{ fieldName: 'doi' }"
          (optionClicked)="onFieldContextMenuOptionClicked($event)"
        ></rl-field-context-menu>
      </div>
    </div>

    <div
      class="d-flex gap-2 align-items-baseline"
      *ngIf="visibleFields.fields.lcn"
    >
      <div class="flex-grow-1">
        <div class="form-group">
          <label for="lcn-{{ id }}" i18n="@@resourceEditForm-label-lcn"
            >Local Control Number</label
          >
          <input
            id="lcn-{{ id }}"
            type="text"
            formControlName="lcn"
            class="form-control"
          />
        </div>
      </div>
      <div>
        <rl-field-context-menu
          [field]="{ fieldName: 'lcn' }"
          (optionClicked)="onFieldContextMenuOptionClicked($event)"
        ></rl-field-context-menu>
      </div>
    </div>

    <ng-container
      formArrayName="optionalIsbn10s"
      *ngFor="let isbn10 of optionalIsbn10s.controls; index as i"
    >
      <div class="d-flex gap-2 align-items-baseline">
        <div class="flex-grow-1">
          <div class="form-group" [formGroupName]="i">
            <label
              for="isbn10-{{ id }}-{{ i }}"
              i18n="@@resourceEditForm-label-isbn10"
              >ISBN 10</label
            >
            <input
              id="isbn10-{{ id }}-{{ i }}"
              type="text"
              formControlName="isbn10"
              class="form-control"
            />
          </div>
        </div>
        <div>
          <rl-field-context-menu
            [field]="{ fieldName: 'optionalIsbn10s', index: i }"
            (optionClicked)="onFieldContextMenuOptionClicked($event)"
          ></rl-field-context-menu>
        </div>
      </div>
    </ng-container>

    <ng-container
      formArrayName="optionalIsbn13s"
      *ngFor="let isbn13 of optionalIsbn13s.controls; index as i"
    >
      <div class="d-flex gap-2 align-items-baseline">
        <div class="flex-grow-1">
          <div class="form-group" [formGroupName]="i">
            <label
              for="isbn13-{{ id }}-{{ i }}"
              i18n="@@resourceEditForm-label-isbn13"
              >ISBN 13</label
            >
            <input
              id="isbn13-{{ id }}-{{ i }}"
              type="text"
              formControlName="isbn13"
              class="form-control"
            />
          </div>
        </div>
        <div>
          <rl-field-context-menu
            [field]="{ fieldName: 'optionalIsbn13s', index: i }"
            (optionClicked)="onFieldContextMenuOptionClicked($event)"
          ></rl-field-context-menu>
        </div>
      </div>
    </ng-container>

    <ng-container
      formArrayName="issns"
      *ngFor="let issn of issns.controls; index as i"
    >
      <div class="d-flex gap-2 align-items-baseline">
        <div class="flex-grow-1">
          <div class="form-group" [formGroupName]="i">
            <label
              for="issn-{{ id }}-{{ i }}"
              i18n="@@resourceEditForm-label-issn"
              >ISSN</label
            >
            <input
              id="issn-{{ id }}-{{ i }}"
              type="text"
              formControlName="issn"
              class="form-control"
            />
          </div>
        </div>
        <div>
          <rl-field-context-menu
            [field]="{ fieldName: 'issns', index: i }"
            (optionClicked)="onFieldContextMenuOptionClicked($event)"
          ></rl-field-context-menu>
        </div>
      </div>
    </ng-container>

    <ng-container
      formArrayName="eissns"
      *ngFor="let eissn of eissns.controls; index as i"
    >
      <div class="d-flex gap-2 align-items-baseline">
        <div class="flex-grow-1">
          <div class="form-group" [formGroupName]="i">
            <label
              for="eissn-{{ id }}-{{ i }}"
              i18n="@@resourceEditForm-label-eissn"
              >EISSN</label
            >
            <input
              id="eissn-{{ id }}-{{ i }}"
              type="text"
              formControlName="eissn"
              class="form-control"
            />
          </div>
        </div>
        <div>
          <rl-field-context-menu
            [field]="{ fieldName: 'eissns', index: i }"
            (optionClicked)="onFieldContextMenuOptionClicked($event)"
          ></rl-field-context-menu>
        </div>
      </div>
    </ng-container>
  </fieldset>

  <fieldset
    class="qa-resource-edit__other"
    *ngIf="
      visibleFields.fields.identifier ||
      visibleFields.fields.publisher_names ||
      visibleFields.fields.places_of_publication ||
      visibleFields.fields.page_start ||
      visibleFields.fields.page_end ||
      visibleFields.fields.format ||
      visibleFields.fields.location ||
      visibleFields.fields.court ||
      visibleFields.fields.series ||
      visibleFields.fields.number
    "
  >
    <legend i18n="@@resourceEditForm-group-other">Other information</legend>

    <div
      class="d-flex gap-2 align-items-baseline"
      *ngIf="visibleFields.fields.identifier"
    >
      <div class="flex-grow-1">
        <div class="form-group">
          <label
            for="identifier-{{ id }}"
            i18n="@@resourceEditForm-label-identifier"
            >Identifier</label
          >
          <input
            id="identifier-{{ id }}"
            type="text"
            formControlName="identifier"
            class="form-control"
          />
        </div>
      </div>
      <div>
        <rl-field-context-menu
          [field]="{ fieldName: 'identifier' }"
          (optionClicked)="onFieldContextMenuOptionClicked($event)"
        ></rl-field-context-menu>
      </div>
    </div>

    <ng-container
      formArrayName="publisher_names"
      *ngFor="let publisherName of publisher_names.controls; index as i"
    >
      <div class="d-flex gap-2 align-items-baseline">
        <div class="flex-grow-1">
          <div class="form-group" [formGroupName]="i">
            <label
              for="publisherName-{{ id }}-{{ i }}"
              i18n="@@resourceEditForm-label-publisherName"
              >Publisher Name</label
            >
            <input
              id="publisherName-{{ id }}-{{ i }}"
              type="text"
              formControlName="publisherName"
              class="form-control"
            />
          </div>
        </div>
        <div>
          <rl-field-context-menu
            [field]="{ fieldName: 'publisher_names', index: i }"
            (optionClicked)="onFieldContextMenuOptionClicked($event)"
          ></rl-field-context-menu>
        </div>
      </div>
    </ng-container>

    <ng-container
      formArrayName="places_of_publication"
      *ngFor="
        let placeOfPublication of places_of_publication.controls;
        index as i
      "
    >
      <div class="d-flex gap-2 align-items-baseline">
        <div class="flex-grow-1">
          <div class="form-group" [formGroupName]="i">
            <label
              for="placeOfPublication-{{ id }}-{{ i }}"
              i18n="@@resourceEditForm-label-placeOfPublication"
              >Place of Publication</label
            >
            <input
              id="placeOfPublication-{{ id }}-{{ i }}"
              type="text"
              formControlName="placeOfPublication"
              class="form-control"
            />
          </div>
        </div>
        <div>
          <rl-field-context-menu
            [field]="{ fieldName: 'places_of_publication', index: i }"
            (optionClicked)="onFieldContextMenuOptionClicked($event)"
          ></rl-field-context-menu>
        </div>
      </div>
    </ng-container>

    <div
      class="d-flex gap-2 align-items-baseline"
      *ngIf="visibleFields.fields.page_start"
    >
      <div class="flex-grow-1">
        <div class="form-group">
          <label
            for="page_start-{{ id }}"
            i18n="@@resourceEditForm-label-startPage"
            >Start page</label
          >
          <input
            id="page_start-{{ id }}"
            type="text"
            formControlName="page_start"
            class="form-control"
          />
        </div>
      </div>
      <div>
        <rl-field-context-menu
          [field]="{ fieldName: 'page_start' }"
          (optionClicked)="onFieldContextMenuOptionClicked($event)"
        ></rl-field-context-menu>
      </div>
    </div>

    <div
      class="d-flex gap-2 align-items-baseline"
      *ngIf="visibleFields.fields.page_end"
    >
      <div class="flex-grow-1">
        <div class="form-group">
          <label for="page_end-{{ id }}" i18n="@@resourceEditForm-label-endPage"
            >End page</label
          >
          <input
            id="page_end-{{ id }}"
            type="text"
            formControlName="page_end"
            class="form-control"
          />
        </div>
      </div>
      <div>
        <rl-field-context-menu
          [field]="{ fieldName: 'page_end' }"
          (optionClicked)="onFieldContextMenuOptionClicked($event)"
        ></rl-field-context-menu>
      </div>
    </div>

    <div
      class="d-flex gap-2 align-items-baseline"
      *ngIf="visibleFields.fields.format"
    >
      <div class="flex-grow-1">
        <div class="form-group">
          <label for="format-{{ id }}" i18n="@@resourceEditForm-label-format"
            >Format</label
          >
          <input
            id="format-{{ id }}"
            type="text"
            formControlName="format"
            class="form-control"
          />
        </div>
      </div>
      <div>
        <rl-field-context-menu
          [field]="{ fieldName: 'format' }"
          (optionClicked)="onFieldContextMenuOptionClicked($event)"
        ></rl-field-context-menu>
      </div>
    </div>

    <div
      class="d-flex gap-2 align-items-baseline"
      *ngIf="visibleFields.fields.location"
    >
      <div class="flex-grow-1">
        <div class="form-group">
          <label
            for="location-{{ id }}"
            i18n="@@resourceEditForm-label-location"
            >Location</label
          >
          <input
            id="location-{{ id }}"
            type="text"
            formControlName="location"
            class="form-control"
          />
        </div>
      </div>
      <div>
        <rl-field-context-menu
          [field]="{ fieldName: 'location' }"
          (optionClicked)="onFieldContextMenuOptionClicked($event)"
        ></rl-field-context-menu>
      </div>
    </div>

    <div
      class="d-flex gap-2 align-items-baseline"
      *ngIf="visibleFields.fields.court"
    >
      <div class="flex-grow-1">
        <div class="form-group">
          <label for="court-{{ id }}" i18n="@@resourceEditForm-label-court"
            >Court</label
          >
          <input
            id="court-{{ id }}"
            type="text"
            formControlName="court"
            class="form-control"
          />
        </div>
      </div>
      <div>
        <rl-field-context-menu
          [field]="{ fieldName: 'court' }"
          (optionClicked)="onFieldContextMenuOptionClicked($event)"
        ></rl-field-context-menu>
      </div>
    </div>

    <div
      class="d-flex gap-2 align-items-baseline"
      *ngIf="visibleFields.fields.series"
    >
      <div class="flex-grow-1">
        <div class="form-group">
          <label for="series-{{ id }}" i18n="@@resourceEditForm-label-series"
            >Series</label
          >
          <input
            id="series-{{ id }}"
            type="text"
            formControlName="series"
            class="form-control"
          />
        </div>
      </div>
      <div>
        <rl-field-context-menu
          [field]="{ fieldName: 'series' }"
          (optionClicked)="onFieldContextMenuOptionClicked($event)"
        ></rl-field-context-menu>
      </div>
    </div>

    <div
      class="d-flex gap-2 align-items-baseline"
      *ngIf="visibleFields.fields.number"
    >
      <div class="flex-grow-1">
        <div class="form-group">
          <label for="number-{{ id }}" i18n="@@resourceEditForm-label-number"
            >Number</label
          >
          <input
            id="number-{{ id }}"
            type="text"
            formControlName="number"
            class="form-control"
          />
        </div>
      </div>
      <div>
        <rl-field-context-menu
          [field]="{ fieldName: 'number' }"
          (optionClicked)="onFieldContextMenuOptionClicked($event)"
        ></rl-field-context-menu>
      </div>
    </div>
  </fieldset>
</form>
